// First, before anything loads react-dom: see the file.
import './react-perf-track-off';
import {AuthProvider, ErrorProvider} from '@enter/core';
import * as Sentry from '@sentry/react';
import { browserTracingIntegration, breadcrumbsIntegration, replayIntegration } from '@sentry/react';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import App from './app';
import * as serviceWorker from './serviceWorker';

const ProvidedApp = (): React.ReactElement => (
    <ErrorProvider>
        <AuthProvider clientId="PROVIDER_DASHBOARD">
            <App />
        </AuthProvider>
    </ErrorProvider>
);

Sentry.init({
    dsn: 'https://1f47a2c2f68648138449819022339cf5@o323927.ingest.sentry.io/6118404',
    integrations: [
        browserTracingIntegration(),
        breadcrumbsIntegration({
            console: false
        }),
        replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
            networkDetailAllowUrls: [/.*/],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    release: `${process.env.REACT_APP_PACKAGE_NAME}-${process.env.NODE_ENV}-${process.env.SENTRY_RELEASE}`,
});

const root = createRoot(document.getElementById('root')!);
root.render(<ProvidedApp />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
